import { STATIC_CONTENT_URL } from 'constants';

import { HeartBoxIcon } from './HeartBoxIcon';
import { HourglassIcon } from './HourglassIcon';
import { MemberDealsAisleBannerIcon } from './MemberDealsAisleBannerIcon';
import PlusBenefitsSaveFoodIcon from './PlusBenefitsSaveFoodIcon';
import PlusBenefitsShippingIcon from './PlusBenefitsShippingIcon';
import PlusBenefitsWeeklyDealsIcon from './PlusBenefitsWeeklyDealsIcon';

export { SocialImpactIcon } from './SocialImpactIcon';

const plusMembershipIconsUrl = `${STATIC_CONTENT_URL}boysenberry/plusmembership/`;

// Full icons
const BOX_WITH_HEART_ICON_URL = `${plusMembershipIconsUrl}box-with-heart-icon.png`;
const HAND_HOLDING_BOWL_ICON_URL = `${plusMembershipIconsUrl}hand-holding-bowl-icon.png`;
const RIBBON_WITH_COIN_ICON_URL = `${plusMembershipIconsUrl}ribbon-with-coin-icon.png`;
const TRUCK_ICON_URL = `${plusMembershipIconsUrl}truck-icon.png`;
const COIN_WITH_STAR_ICON_URL = `${plusMembershipIconsUrl}coin-with-star.png`;
const COIN_WITH_STAR_ICON_V2_URL = `${plusMembershipIconsUrl}coins-with-stars-v2.png`;
const TWO_COINS_WITH_STAR_ICON_URL = `${plusMembershipIconsUrl}two-coins-with-star.png`;
const RIBBON_WITH_STAR_ICON_URL = `${plusMembershipIconsUrl}ribbon-with-star.png`;
const RIBBON_WITH_STAR_ICON_V3_URL = `${plusMembershipIconsUrl}ribbon-with-stars-v3.png`;
const ODDS_ENDS_DEALS_ICON_URL = `${plusMembershipIconsUrl}odds-ends-benefit-icon.png`;

// Cropped icons
const BOX_WITH_HEART_ICON_CROPPED_URL = `${plusMembershipIconsUrl}box-with-heart-icon-cropped2.png`;
const HAND_HOLDING_BOWL_ICON_CROPPED_URL = `${plusMembershipIconsUrl}hand-holding-bowl-icon-cropped.png`;
const RIBBON_WITH_COIN_ICON_CROPPED_URL = `${plusMembershipIconsUrl}ribbon-with-coin-icon-cropped.png`;
const TRUCK_ICON_CROPPED_URL = `${plusMembershipIconsUrl}truck-icon-cropped.png`;

// Renewal icons
const RENEWAL_TRUCK_ICON_URL = `${plusMembershipIconsUrl}mini-truck-icon.svg`;
const RENEWAL_TAG_ICON_URL = `${plusMembershipIconsUrl}mini-tag-icon.svg`;
const RENEWAL_PLATE_ICON_URL = `${plusMembershipIconsUrl}mini-plate-icon.svg`;

export {
    BOX_WITH_HEART_ICON_URL,
    HAND_HOLDING_BOWL_ICON_URL,
    RIBBON_WITH_COIN_ICON_URL,
    TRUCK_ICON_URL,
    COIN_WITH_STAR_ICON_URL,
    COIN_WITH_STAR_ICON_V2_URL,
    TWO_COINS_WITH_STAR_ICON_URL,
    RIBBON_WITH_STAR_ICON_URL,
    RIBBON_WITH_STAR_ICON_V3_URL,
    BOX_WITH_HEART_ICON_CROPPED_URL,
    HAND_HOLDING_BOWL_ICON_CROPPED_URL,
    RIBBON_WITH_COIN_ICON_CROPPED_URL,
    TRUCK_ICON_CROPPED_URL,
    ODDS_ENDS_DEALS_ICON_URL,
    PlusBenefitsShippingIcon,
    PlusBenefitsSaveFoodIcon,
    PlusBenefitsWeeklyDealsIcon,
    HeartBoxIcon,
    HourglassIcon,
    MemberDealsAisleBannerIcon,
    RENEWAL_TRUCK_ICON_URL,
    RENEWAL_TAG_ICON_URL,
    RENEWAL_PLATE_ICON_URL,
};
